import '../__generated__/styles/progress-meter.css';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import { useTheme } from '@swift-paypal/pp-react-theme';
import clsx from 'clsx';

var styles = {"ppvx_progress-meter":"ppvx_progress-meter___2-8-0","ppvx_progress__label":"ppvx_progress__label___2-8-0","ppvx_progress-meter--inverse":"ppvx_progress-meter--inverse___2-8-0","ppvx_progress__steps":"ppvx_progress__steps___2-8-0","ppvx_progress__title":"ppvx_progress__title___2-8-0","ppvx--v2":"ppvx--v2___2-8-0","ppvx--v1":"ppvx--v1___2-8-0","ppvx_progress-meter--color-magenta":"ppvx_progress-meter--color-magenta___2-8-0","ppvx_progress-meter--color-purple":"ppvx_progress-meter--color-purple___2-8-0","ppvx_progress-meter--color-blue":"ppvx_progress-meter--color-blue___2-8-0","ppvx_progress__label--align-left":"ppvx_progress__label--align-left___2-8-0","ppvx_progress-meter--size-sm":"ppvx_progress-meter--size-sm___2-8-0","ppvx_progress-meter--circle":"ppvx_progress-meter--circle___2-8-0","ppvx_progress-meter--circle__inner":"ppvx_progress-meter--circle__inner___2-8-0","ppvx_progress-meter--circle__progress-indicator":"ppvx_progress-meter--circle__progress-indicator___2-8-0","ppvx_progress-meter--circle--sm":"ppvx_progress-meter--circle--sm___2-8-0","ppvx_progress-meter--circle--blue":"ppvx_progress-meter--circle--blue___2-8-0","ppvx_progress-meter--circle--green":"ppvx_progress-meter--circle--green___2-8-0","ppvx_progress-meter--circle--purple":"ppvx_progress-meter--circle--purple___2-8-0","ppvx_progress-meter--circle__progress":"ppvx_progress-meter--circle__progress___2-8-0"};

var generateId = function () {
  return "progress-meter_".concat(Math.random().toFixed(8).toString().replace('0.', ''));
};

var ProgressMeter = function (_ref) {
  var _clsx;

  var className = _ref.className,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? generateId() : _ref$id,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 0 : _ref$max,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      steps = _ref.steps,
      size = _ref.size,
      title = _ref.title,
      color = _ref.color,
      alignLabelsLeft = _ref.alignLabelsLeft,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["className", "id", "max", "value", "inverse", "steps", "size", "title", "color", "alignLabelsLeft", "theme"]);

  var _theme = useTheme('Progess Meter', theme);

  var isThemeV2 = _theme && _theme === 'v2';
  var progressMeterClasses = clsx(styles['ppvx_progress-meter'], (_clsx = {}, _defineProperty(_clsx, styles['ppvx--v2'], isThemeV2), _defineProperty(_clsx, styles['ppvx_progress-meter--inverse'], inverse), _defineProperty(_clsx, styles["ppvx_progress-meter--color-".concat(color)], color && isThemeV2), _defineProperty(_clsx, styles["ppvx_progress-meter--size-".concat(size)], size && isThemeV2), _clsx), className);
  var labelClasses = clsx(styles.ppvx_progress__label, _defineProperty({}, styles['ppvx_progress__label--align-left'], isThemeV2 && alignLabelsLeft));
  var renderLabel = /*#__PURE__*/React.createElement("label", {
    className: labelClasses,
    htmlFor: id
  }, steps && /*#__PURE__*/React.createElement("span", {
    className: styles.ppvx_progress__steps
  }, steps), title && /*#__PURE__*/React.createElement("span", {
    className: styles.ppvx_progress__title
  }, title));
  return /*#__PURE__*/React.createElement("div", {
    className: progressMeterClasses
  }, /*#__PURE__*/React.createElement("progress", _extends({
    id: id,
    max: max,
    value: value
  }, rest, {
    role: "progressbar"
  })), renderLabel);
};

var STROKE_WIDTH_PERCENT = 4 / 96 * 100; // 4px (stroke-width) / 96px (total-size) * 100

var STROKE_WIDTH_PERCENT_SM = 3 / 48 * 100; // 3px (stroke-width) / 48px (total-size) * 100

var SVG_CIRCLE_RADIUS = 50;
var CircleProgressMeter = forwardRef(function (props, ref) {
  var className = props.className,
      _props$max = props.max,
      max = _props$max === void 0 ? 1 : _props$max,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      color = props.color,
      label = props.label,
      size = props.size,
      children = props.children,
      rest = _objectWithoutProperties(props, ["className", "max", "value", "color", "label", "size", "children"]);

  var radius = size === 'sm' ? SVG_CIRCLE_RADIUS - STROKE_WIDTH_PERCENT_SM / 2 : SVG_CIRCLE_RADIUS - STROKE_WIDTH_PERCENT / 2;
  var maxDashOffset = 2 * Math.PI * radius;

  /* Commenting out code related to draw out animation
  const [dashOffset, setDashOffset] = useState(maxDashOffset)
   useEffect(() => {
    const newDashOffset = maxDashOffset - (value / max) * maxDashOffset
     setDashOffset(newDashOffset)
  }, [value])
  */
  var cls = clsx(styles['ppvx_progress-meter--circle'], size === 'sm' && styles['ppvx_progress-meter--circle--sm'], color && styles["ppvx_progress-meter--circle--".concat(color)], className);
  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement("svg", {
    className: styles['ppvx_progress-meter--circle__progress-indicator'],
    "aria-hidden": "true",
    style: {
      strokeDasharray: maxDashOffset,
      strokeDashoffset: maxDashOffset - value / max * maxDashOffset
    },
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: SVG_CIRCLE_RADIUS,
    cy: SVG_CIRCLE_RADIUS,
    r: radius
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_progress-meter--circle__inner'],
    "aria-hidden": "true"
  }, children), /*#__PURE__*/React.createElement("label", {
    className: styles['ppvx_progress-meter--circle__progress']
  }, label, /*#__PURE__*/React.createElement("progress", _extends({
    max: max,
    value: value
  }, rest, {
    role: "progressbar",
    ref: ref
  }))));
});
var IconProgressMeter = forwardRef(function (props, ref) {
  var iconComponent = props.iconComponent,
      size = props.size,
      rest = _objectWithoutProperties(props, ["iconComponent", "size"]);

  var iconSize = size === 'sm' ? 'sm' : 'xl2';
  return /*#__PURE__*/React.createElement(CircleProgressMeter, _extends({
    size: size,
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(iconComponent, {
    size: iconSize
  }));
});
var ImageProgressMeter = forwardRef(function (props, ref) {
  var imageSrc = props.imageSrc,
      rest = _objectWithoutProperties(props, ["imageSrc"]);

  return /*#__PURE__*/React.createElement(CircleProgressMeter, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement("img", {
    src: imageSrc
  }));
});

export { CircleProgressMeter, IconProgressMeter, ImageProgressMeter, ProgressMeter };
